import { DefaultService } from '@/services/DefaultService';

export default class AssAtendimentoContatoService extends DefaultService {
    constructor(http, router, env) {
        super(http, router, env);
    }

    findAll(column, order, situacao, uuid, ...params) {
        return this._http.get(encodeURI(`${this._env}/ven/atendimento/assatendimentocontato.json?column=${column}&order=${order}&situacao=${situacao}&uuid=${uuid}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
	findAllCombo(uuid) {
		return this._http.get(encodeURI(`${this._env}/ven/atendimento/getcombo/assatendimentocontato.json?uuid=${uuid}`), this._headers).then(res => {
      return res.body;
		}, err => {
      this.verifyError(err);
      throw new Error('Problems while jobs are loading');
		});
	}

    save(ass) {
        return this._http.post(`${this._env}/ven/atendimento/assatendimentocontato`, ass, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
}